exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-label {\r\n  font-size: small;\r\n}\r\n\r\n.dropdown-menu {\r\n  max-height: 300px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.modal-header {\r\n  color: white;\r\n  background-color: #171514;\r\n}\r\n\r\n.info-fields {\r\n  font-size: small;\r\n}\r\n\r\n.modal-footer {\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.btn {\r\n  border-color: #a3a3a3;\r\n}\r\n\r\n.smaller-text {\r\n  font-size: smaller;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/views/view-standard/popups/add-new-questions/add-new-questions.component.css
// module id = ../../../../../src/app/content-page/views/view-standard/popups/add-new-questions/add-new-questions.component.css
// module chunks = main